import { render, staticRenderFns } from "./CBoxButton.vue?vue&type=template&id=5d9cd276&scoped=true&"
import script from "./CBoxButton.vue?vue&type=script&lang=js&"
export * from "./CBoxButton.vue?vue&type=script&lang=js&"
import style0 from "./CBoxButton.vue?vue&type=style&index=0&id=5d9cd276&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9cd276",
  null
  
)

export default component.exports